export function debounce(cb: Function, delay = 400) {
  let timeout: NodeJS.Timeout;
  return function (...args: any[]) {
    clearTimeout(timeout);
    return new Promise((r) => {
      timeout = setTimeout(() => r(cb(...args)), delay);
    });
  };
}
